import { useState } from 'react';
import { copyToClipboard } from '../../utils/copy.js';

// Wrapper pentru orice element care să fie copiabil cu un click.
// Afișează un tooltip mic cu „Copiat!" timp de 1.5s după copiere.
// Poate fi folosit pe orice child (text, badge, număr).
export function Copyable({ value, children, className = '', as: Tag = 'button', title = 'Click pentru a copia' }) {
  const [copied, setCopied] = useState(false);

  async function handleClick(e) {
    e.stopPropagation();
    e.preventDefault();
    const ok = await copyToClipboard(value);
    if (ok) {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  }

  return (
    <Tag
      type={Tag === 'button' ? 'button' : undefined}
      onClick={handleClick}
      title={copied ? 'Copiat!' : title}
      className={`relative inline-flex items-center gap-1 cursor-pointer transition-colors ${className}`}
    >
      {children}
      {copied && (
        <span className="absolute -top-7 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-ink px-2 py-0.5 text-[10px] font-medium text-cream shadow">
          Copiat!
        </span>
      )}
    </Tag>
  );
}
